export default "__VITE_ASSET__BqrShNtb__"